var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"bg-default-card",attrs:{"header":_vm.uLang('app.enrol_candidate_to_trajectory'),"header-tag":"h4"}},[(_vm.relation)?_c('trajectory-enrolment-form',{attrs:{"relation":_vm.relation,"override-endpoint":_vm.overrideEndpoint}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }